
<div style="width: 100%">
    <div *ngIf="!selectedModule" [formGroup]="moduleSelectorForm" fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="0 1 100%" color="accent" class="m-8 ml-16">
            <mat-label fxFlex="100">{{'DYNAMIC_FILTERS.MODULE_SELECTOR' | translate}}</mat-label>
            <mat-select formControlName="moduleSelect">          
                <mat-option *ngFor="let item of moduleSelectData" [value]="item">
                    <ng-container [ngSwitch]="item.description">
                        <span *ngSwitchCase="dynamicFiltersModulesDescriptions.Alerts">{{'NAV.ALERTS' | translate}}</span>
                        <span *ngSwitchCase="dynamicFiltersModulesDescriptions.Cases">{{'NAV.CASES' | translate}}</span>
                        <span *ngSwitchCase="dynamicFiltersModulesDescriptions.Complaint">{{'NAV.COMPLAINTS' | translate}}</span>
                        <span *ngSwitchDefault>{{'DYNAMIC_FILTERS.NO_MODULE_AVALAIBLE' | translate}}</span>
                    </ng-container>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div *ngIf="moduleSelectorForm?.get('moduleSelect')?.value?.description || selectedModule" [formGroup]="selectorForm" fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="0 1 100%" color="accent" class="m-8 ml-16">
            <mat-label fxFlex="100%" *ngIf="!selectedModule">
                <ng-container [ngSwitch]="moduleSelectorForm?.get('moduleSelect')?.value?.description">
                    <span *ngSwitchCase="dynamicFiltersModulesDescriptions.Alerts">{{'NAV.ALERTS' | translate}}</span>
                    <span *ngSwitchCase="dynamicFiltersModulesDescriptions.Cases">{{'NAV.CASES' | translate}}</span>
                    <span *ngSwitchCase="dynamicFiltersModulesDescriptions.Complaint">{{'NAV.COMPLAINTS' | translate}}</span>
                    <span *ngSwitchDefault>{{'DYNAMIC_FILTERS.NO_MODULE_AVALAIBLE' | translate}}</span>
                </ng-container>
            </mat-label>
            <mat-label *ngIf="selectedModule">
                <span *ngIf="moduleSelectorForm?.get('moduleSelect')?.value?.description">{{filtersLabel | translate}}</span>
                <span *ngIf="!moduleSelectorForm?.get('moduleSelect')?.value?.description">{{'DYNAMIC_FILTERS.NO_MODULE_AVALAIBLE' | translate}}</span>
            </mat-label>
            
            
            <mat-select formControlName="workflowSelect" fxFlex="100%" [disabled]="workflowsSelectData.length < 1">     
                <mat-option *ngIf="workflowsSelectData?.length < 1" [value]="0">{{'DYNAMIC_FILTERS.NO_FORMS_AVALAIBLE' | translate}}</mat-option>     
                <mat-option *ngFor="let item of workflowsSelectData" [value]="item.id">
                    <span>{{item.description}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <ng-container > <!--[ngSwitch]="module?.moduleId"-->
        <!-- <ng-container *ngSwitchCase="MODULES.Complaints">
            <div [formGroup]="selectorStepForm" fxLayout="row wrap">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="0 1 350px" color="accent" class="m-8 ml-16"
                     *ngIf="!loadingData && complaintFormsResult.length > 0">
                    <mat-label fxFlex="100">{{selectStepLabel | translate}}</mat-label>
                    <mat-select formControlName="stepSelected">          
                        <mat-option *ngFor="let item of complaintFormsResult" [value]="item.id">
                            <span>{{item.name}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container> -->
        <!-- <div [formGroup]="selectorStepForm" fxLayout="row wrap">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="0 1 100%" color="accent" class="m-8 ml-16"
                *ngIf="!loadingData && stepsResult.length > 0">
                <mat-label fxFlex="100">{{selectStepLabel | translate}}</mat-label>
                <mat-select formControlName="stepSelected">          
                    <mat-option *ngFor="let item of stepsResult" [value]="item.stepId">
                        <span>{{item.stepTitle}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->
    

        <ng-container *ngIf="module?.moduleId !== MODULES.Complaints">
            <div [formGroup]="selectorStepForm" fxLayout="row wrap">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="0 1 100%" color="accent" class="m-8 ml-16"
                     *ngIf="!loadingData && stepsResult?.length > 0 && selectorForm.get('workflowSelect').value > 0">
                    <mat-label fxFlex="100">{{selectStepLabel | translate}}</mat-label>
                    <mat-select formControlName="stepSelected">          
                        <mat-option *ngFor="let item of stepsResult" [value]="item.stepId">
                            <span>{{item.stepTitle}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container>
    </ng-container>

    <div fxLayout="row wrap">
        <mat-spinner [diameter]="50" *ngIf="loadingSearch" style="position: absolute;z-index: 1000;left: 50%;top: 50%;"></mat-spinner>
        <div *ngIf="!loadingData && stepsResult?.length > 0"class="mt-16" fxLayout="column" style="width: 100%">
            <ng-container *ngFor="let step of stepsResult" style="width: 100%">
                <mat-accordion fxFlex="100%"  style="width: 100%" class="my-8" *ngIf="step.stepId == selectorStepForm.get('stepSelected').value">
                    <mat-expansion-panel [expanded]="false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>    
                                {{step.stepTitle}}
                            </mat-panel-title>
                        </mat-expansion-panel-header> 
                        
                        <mat-card class="step-container">
                            <app-form-component [readonly]="loadingSearch" [id]="step.stepId" [clearQuestionButtons]="true" #formComponent
                            [formData]="step.formDto" maxLength="1000" [dynamicFilter]="true"></app-form-component>
                            <mat-divider></mat-divider>
                            <div class="buttons-container">  <!-- fxLayout="column"-->
                                <div fxFlex="100" fxLayout="row wrap" class="p-8">
                                    <!-- <div fxFlex="100" class="my-8">
                                        <span class="minchar-warn">{{'ALERTS.DYNAMIC_FILTERS.GLOBAL_MIN_CHAR_HINT' | translate}}</span>
                                    </div> -->

                                    <div fxFlex="100" fxLayout="row">
                                        <button fxFlex="45" color="accent" mat-raised-button class="mx-8" 
                                            (click)="applyStepFilters(step.stepId)" [disabled]="loadingSearch">
                                            {{'ALERTS.DYNAMIC_FILTERS.APPLY' | translate}}
                                        </button>
                                        <button fxFlex="45" color="primary" mat-raised-button class="mx-8" 
                                            (click)="clearFilters(step.stepId)" [disabled]="loadingSearch">
                                            {{'ALERTS.DYNAMIC_FILTERS.CLEAR_ANSWERS' | translate}}
                                        </button>
                                        <!-- ALERTS.DYNAMIC_FILTERS.CLEAR_ALL_FILTERS -->
                                    </div>
                                </div>
                            </div>
                        </mat-card>
                    </mat-expansion-panel> 
                </mat-accordion>
            </ng-container>   
        </div>

        <div *ngIf="!loadingData && complaintFormsResult?.length > 0"class="mt-16" fxLayout="column" style="width: 100%">
            <ng-container *ngFor="let complaintForm of complaintFormsResult" style="width: 100%">
                <mat-accordion fxFlex="100%"  style="width: 100%" class="my-8"> <!-- *ngIf="complaintForm.stepId == selectorStepForm.get('stepSelected').value"-->
                    <mat-expansion-panel [expanded]="false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>    
                                {{complaintForm.name}}
                            </mat-panel-title>
                        </mat-expansion-panel-header> 
                        
                        <mat-card class="step-container">
                            <app-form-component [readonly]="loadingSearch" [id]="complaintForm.id" [clearQuestionButtons]="true" #formComponent
                            [formData]="complaintForm" maxLength="1000" [dynamicFilter]="true"></app-form-component>
                            <mat-divider></mat-divider>
                            <div class="buttons-container">  <!-- fxLayout="column"-->
                                <div fxFlex="100" fxLayout="row wrap" class="p-8">
                                    <!-- <div fxFlex="100" class="my-8">
                                        <span class="minchar-warn">{{'ALERTS.DYNAMIC_FILTERS.GLOBAL_MIN_CHAR_HINT' | translate}}</span>
                                    </div> -->

                                    <div fxFlex="100" fxLayout="row">
                                        <button fxFlex="50" color="accent" mat-raised-button class="mx-8" 
                                            (click)="applyStepFilters(complaintForm.id)" [disabled]="loadingSearch">
                                            {{'ALERTS.DYNAMIC_FILTERS.APPLY' | translate}}
                                        </button>
                                        <button fxFlex="40" color="primary" mat-raised-button class="mx-8" 
                                            (click)="clearFilters(complaintForm.id)" [disabled]="loadingSearch">
                                            {{'ALERTS.DYNAMIC_FILTERS.CLEAR_ANSWERS' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </mat-card>
                    </mat-expansion-panel> 
                </mat-accordion>
            </ng-container>   
        </div>
        <div style="width: 100%" *ngIf="complaintFormsResult?.length > 0 || stepsResult?.length > 0">
            <div fxFlex="100" fxLayout="row">
                <mat-card class="clear-all-container">
                    <button fxFlex="95" mat-raised-button class="mx-8 button-clear-all" 
                        (click)="clearAllFilters()" [disabled]="loadingSearch">
                        {{'ALERTS.DYNAMIC_FILTERS.CLEAR_ALL_FILTERS' | translate}}
                    </button>
                </mat-card>
            </div>
        </div>

        <div style="width: 100%; display: flex; justify-content: space-around" class="mt-32 p-16">
            <mat-spinner [diameter]="45" *ngIf="loadingData"></mat-spinner>
        </div>
    </div>
</div>
